import script from "./ApplianceTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ApplianceTable.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__